import React from 'react'
import { Grid as BaseGrid, ButtonBase, styled } from '@mui/material'
import { PUBLIC_URL } from '../../config/settings/environment'

export const ArrowBack = styled('img')`
  background-color: ${props => props.theme.palette.gray[50]};
  width: 100px;
  height: 20px;
  margin: 0 -30px 0 -40px;
  mask: url(${PUBLIC_URL}/assets/images/arrow-back.svg) no-repeat center / contain;
  &:hover {
    background-color: ${props => props.theme.palette.brand.white};
  }
`

export const BackButton = styled(ButtonBase)`
  &.MuiButtonBase-root {
    align-items: center;
    border-radius: 2rem;
    cursor: pointer;
    display: inline-flex;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    font-weight: 700;
    height: 40px;
    justify-content: center;
    line-height: 21px;
    margin: ${props => props.margin};
    width: 180px;
    padding: 0 20px 0 20px;
    transition:
      background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out,
      color 0.15s ease-in-out;
    user-select: none;
    background-color: ${({ disabled, theme }) =>
      disabled ? theme.palette.custom.gray[20.2] : theme.palette.custom.gray[50.1]};
    border: ${({ disabled, theme }) => (disabled ? 'none' : `1px solid ${theme.palette.gray[50]}`)};
    color: ${({ disabled, theme }) => (disabled ? theme.palette.brand.white : theme.palette.gray[50])};

    ${props => props.theme.breakpoints.only('xs')} {
      width: 136px;
      margin: 5px 0;
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem ${props => props.theme.palette.gray[50.4]};
      outline: 0;
    }

    &:active {
      transform: scale(0.98);
    }

    &:hover {
      background-color: ${props => props.theme.palette.gray[50]};
      border-color: ${props => props.theme.palette.gray[50]};
      color: ${props => props.theme.palette.brand.white};

      & img {
        background-color: ${props => props.theme.palette.brand.white};
      }
    }
  }
`

export const Root = styled('div')`
  display: flex;
  height: auto;
  margin: 0;
  width: 100%;
`

export const Logo = styled('img')`
  height: auto;
  pointer-events: none;
  user-select: none;
  width: 215px;
  ${props => props.theme.breakpoints.only('xs')} {
    max-width: 170px;
  }
`

export const LogoLink = styled('a')`
  cursor: pointer;
  float: left;
  margin: 0 26px 0 0;
`

export const Container = styled(({ children, display, float, width, ...props }) => (
  <BaseGrid container {...props}>
    {children}
  </BaseGrid>
))`
  &.MuiGrid-container {
    display: ${props => props.display};
    float: ${props => props.float};
    width: ${props => props.width};
  }
  ${props => props.theme.breakpoints.only('xs')} {
    justify-content: space-between;
  }
`

export const Item = styled(({ children, width, ...props }) => (
  <BaseGrid item {...props}>
    {children}
  </BaseGrid>
))`
  &.MuiGrid-root {
    width: ${props => props.width};
  }
`
